"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactColor = require("react-color");
var _themes = _interopRequireDefault(require("../themes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ColorPickerButton extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      showColorPicker: false
    };
  }
  componentWillReceiveProps(nextProps) {
    const color = nextProps.color;
    if (this.props.color !== color) {
      this.setState({
        color
      });
    }
  }
  toggleColorPicker(e) {
    this.setState({
      showColorPicker: !this.state.showColorPicker
    });
  }
  handleChange(color) {
    const onChangeColor = this.props.onChangeColor;
    this.setState({
      color: color.rgb
    });
    onChangeColor(this.state.color);
  }
  handleChangeColor(color) {
    this.setState({
      showColorPicker: false
    });
    this.props.focusEditor();
  }
  render() {
    const _this$state = this.state,
      showColorPicker = _this$state.showColorPicker,
      color = _this$state.color;
    const _this$props = this.props,
      className = _this$props.className,
      theme = _this$props.theme;
    const presetColors = theme ? _themes.default[theme] : [];
    const colorPickerProps = {
      color,
      presetColors,
      onChangeComplete: this.handleChange.bind(this)
    };
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: className,
      onClick: this.toggleColorPicker.bind(this)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-eyedropper"
    })), showColorPicker ? /*#__PURE__*/_react.default.createElement("div", {
      className: "absolute left-0"
    }, /*#__PURE__*/_react.default.createElement(_reactColor.SketchPicker, colorPickerProps), /*#__PURE__*/_react.default.createElement("button", {
      className: "btn bg-darken-4 white col-12 rounded-bottom",
      onClick: this.handleChangeColor.bind(this)
    }, "Fechar")) : null);
  }
}
var _default = exports.default = ColorPickerButton;